var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groups-list-tree-container",attrs:{"data-qa-selector":"groups_list_tree_container"}},[_c('group-folder',{attrs:{"groups":_vm.groups,"action":_vm.action}}),_vm._v(" "),_c('pagination-links',{staticClass:"d-flex justify-content-center gl-mt-3",attrs:{"change":_vm.change,"page-info":_vm.pageInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }